import type { MatchMinutesOverride, StatusText, TimeOffset } from './types.js';

export const statusTexts: Partial<StatusText> = {
  Pause: { full: 'Paus', short: 'PAUS' },
  AwaitingPenalties: { full: 'Inväntar straffar', short: 'PAUS' },
  Penalties: { full: 'Straffar (STR)', short: 'STR' },
  AwaitingExtratime: { full: 'Inväntar extratid', short: 'PAUS' },
  Halftime: { full: 'Halvtid (HT)', short: 'HT' },
  Fulltime: { full: 'Fulltid (FT)', short: 'FT' },
  Extratime: { full: 'Extratid (ET)', short: 'ET' },
  Overtime: { full: 'Övertid (ÖT)', short: 'ÖT' },
  EndedAfterExtratime: { full: 'Slut efter extratid (ET)', short: 'ET' },
  EndedAfterPenalties: { full: 'Slut efter straffar (STR)', short: 'STR' },
};

export const matchMinutesOverrides: MatchMinutesOverride = [
  'Halftime',
  'AwaitingPenalties',
  'AwaitingExtratime',
  'Extratime',
  'Overtime',
  'Penalties',
];

export const timeOffsets: TimeOffset = {
  FirstHalf: { start: 0, end: 45 },
  SecondHalf: { start: 45, end: 90 },
  FirstExtraPeriod: { start: 90, end: 105 },
  SecondExtraPeriod: { start: 105, end: 120 },
};

export const config = {
  statusTexts,
  matchMinutesOverrides,
  timeOffsets,
};
